// extracted by mini-css-extract-plugin
export default {"leftNavigation":"CarouselLeftNav_leftNavigation__zkfwB"};